import { useTheme } from '@mui/material/styles';
import { getBezierPath } from '@xyflow/react';
import { bool, number, object, string } from 'prop-types';
import React from 'react';

const ChatFlowEdge = ({
  id,
  style = {},
  sourceX,
  sourceY,
  sourcePosition = null,
  targetX,
  targetY,
  targetPosition = null,
  markerEnd = null,
  selected = false,
}) => {
  const theme = useTheme();
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  return (
    <path
      id={id}
      style={{
        ...style,
        fill: 'none',
        stroke: selected ? theme.palette.primary.extraDark : theme.palette.primary.main,
        strokeWidth: selected ? 3 : 1,
      }}
      d={edgePath}
      markerEnd={markerEnd}
    />
  );
};

ChatFlowEdge.propTypes = {
  id: string.isRequired,
  style: object,
  sourceX: number.isRequired,
  sourceY: number.isRequired,
  sourcePosition: string,
  targetX: number.isRequired,
  targetY: number.isRequired,
  targetPosition: string,
  markerEnd: string,
  selected: bool,
};

export default ChatFlowEdge;
